import { Controller } from "@hotwired/stimulus"
import "leaflet";

export default class extends Controller {
   static values = {
      lat: { type: Number, default: 0 },
      lng: { type: Number, default: 0 }
   };

   connect() {
      const lat = this.latValue;
      const lng = this.lngValue;
      const mymap = L.map(this.element, {
         minZoom: 3,
         scrollWheelZoom: false,
         attributionControl: false
      }).setView([lat, lng], 18);

      var myAttrControl = L.control.attribution().addTo(mymap);
      myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');

      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
         attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>',
         tileSize: 512,
         maxZoom: 18,
         zoomOffset: -1,
         id: 'ginto/ck9e69gth273b1itgoq9lx6yb',
         accessToken: window.env.mapboxToken,
      }).addTo(mymap);

      // add a scale at at your map.
      L.control.scale().addTo(mymap);

      L.marker([lat, lng], {
         icon: new L.Icon({
            iconUrl: "/leaflet/images/map-pin.svg",
            iconSize: [40, 56],
            iconAnchor: [20, 56]
         })
      }).addTo(mymap);
   }
}
